import React from "react";
import { fmtDuration } from "@/lib/format";

const GOAL_LINE = {
  performance: "fuelling every session fully so you train hard and adapt",
  maintenance: "matching intake to output to hold your weight while covering training",
  "fat-loss": "running a controlled deficit on easy days while protecting your key sessions",
  recovery: "prioritising protein and recovery fuel to get you back to full training",
};

export default function CoachBrief({ targets, trainingWeek, raceWeek, goal }) {
  const days = targets?.daily || [];
  if (!days.length) return null;

  const totalMin = days.reduce((s, d) => s + (d.trainingMinutes || 0), 0);
  const hours = (totalMin / 60).toFixed(1);
  const sessions = (trainingWeek?.days || []).reduce((s, d) => s + (d.sessions?.length || 0), 0);
  const trained = days.filter((d) => (d.trainingMinutes || 0) > 0);
  const hardest = [...trained].sort((a, b) => b.trainingMinutes - a.trainingMinutes)[0];
  const biggestFuel = [...days].sort((a, b) => b.carb - a.carb)[0];
  const restDays = days.filter((d) => (d.trainingMinutes || 0) === 0);

  const parts = [];
  parts.push(`This is a ${(targets.weeklyDemand || "balanced").toLowerCase()} week — ${hours} h across ${sessions} session${sessions === 1 ? "" : "s"}, ${GOAL_LINE[goal] || "built around your training"}.`);
  if (hardest) parts.push(`${hardest.day} is your biggest day (${fmtDuration(hardest.trainingMinutes)} · ${hardest.energy} kcal), so the week's fuelling is built to protect it.`);
  if (biggestFuel && biggestFuel.carb > 0) parts.push(`Carbs peak on ${biggestFuel.day} at ${biggestFuel.carb} g — front-load them and refuel fast afterwards.`);
  if (restDays.length) parts.push(`${restDays.length} lighter day${restDays.length === 1 ? "" : "s"} (${restDays.map((d) => d.day).join(", ")}) pull carbs back for recovery.`);
  if (raceWeek?.enabled) {
    const rd = days[raceWeek.dayIndex]?.day || "race day";
    parts.push(`It's race week: carb-load into ${rd} and target ${raceWeek.carbsPerHour} g carbs/hr during the event.`);
  }

  return (
    <div data-testid="coach-brief" className="relative border border-[#E2E30A]/30 bg-gradient-to-br from-[#E2E30A]/[0.06] to-transparent p-6 mb-8 print-day">
      <p className="text-base sm:text-lg text-white leading-relaxed print-accent">{parts.join(" ")}</p>
    </div>
  );
}
